import { useMutation } from 'react-query';
import { SEGMENT_USERS_QUERY } from 'api/ListsApi';
import { ApiResponse } from 'services/api';
import { createLazyRestRequest } from 'utils/hooks/api';
import { SegmentUsersQueryParams, SegmentUsersQueryResponse } from '../types/queries';
import { useState } from 'react';

export const useLazySegmentationQuery = () => {
  const [errorMessage, setErrorMessage] = useState<string>();
  const { mutateAsync, data, ...rest } = useMutation(
    createLazyRestRequest({ url: SEGMENT_USERS_QUERY }),
    {
      onError: ({ response }) => {
        setErrorMessage(response?.data?.message);
      },
    },
  );

  const segmentUsersQuery = (
    params: Partial<SegmentUsersQueryParams>,
  ): Promise<ApiResponse<SegmentUsersQueryResponse>> =>
    mutateAsync({
      requestConfig: { url: SEGMENT_USERS_QUERY },
      requestData: { ...params },
    });

  return {
    ...data,
    ...rest,
    errorMessage,
    segmentUsersQuery,
  };
};
